import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthManagerService } from '../auth-manager/auth-manager.service';
import { RegistrationFlowService } from '../registration-flow/registration-flow.service';
import { UserService } from '../user/user.service';
import { User } from 'src/app/interfaces/user';
import { FeatureFlagsService } from '../feature-flag/feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authManager: AuthManagerService,
    private router: Router,
    private registrationFlowService: RegistrationFlowService,
    private userService: UserService,
    private featureFlags: FeatureFlagsService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.authManager.loginBasedOnDomainCookie();

    if (this.authManager.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.redirectUserOrNavigateToDashboard(userResponse);
      });
    }

    if (!this.featureFlags.isEnabled('isHomeScreenAvailable')) {
      this.router.navigate(['/dashboard']);
    }

    return true;
  }

  private redirectUserOrNavigateToDashboard(user: User) {
    this.registrationFlowService.getResumeRoute(user).subscribe((resumeRoute) => {
      // The registration is incomplete -> navigate the user to the step they are on
      if (resumeRoute) {
        this.router.navigate([resumeRoute]);
      } else if (this.router.url !== '/') {
        this.router.navigate(['/dashboard']);
      }
    });
  }
}
